<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-card>
          <PageHeader :title="title" :items="items" style="margin-top: -30px"/>
          <form action="">
            <div class="form-row">
              <div class="col-md-6 col-sm-6 col-lg-4">
                <label for="trade_id" class="col-form-label col-form-label-sm">Select Trade <span style="color: red">*</span></label>
                <select v-model="search_data.trade_id" v-validate="'required'" id="trade_id" name="trade_id" class="form-control form-control-sm">
                  <option :value="''" selected>Select Trade</option>
                  <option v-for="(trade, index) in trades" :key="index" :value="trade.id">
                    {{ trade.id }} : {{trade.desc }}
                  </option>
                </select>
                <div class="invalid-feedback">
                  Please Select Trade
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-4">
                <label for="batch_no" class="col-form-label col-form-label-sm">Select Batch <span style="color: red">*</span></label>
                <select v-model="search_data.batch_no" v-validate="'required'"  id="batch_no" name="batch_no"
                        class="form-control form-control-sm">
                  <option :value="''" selected>Select Batch no.</option>
                  <option value="01">01</option>
                  <option value="02">02</option>
                  <option value="03">03</option>
                  <option value="04">04</option>
                  <option value="05">05</option>
                  <option value="06">06</option>
                  <option value="07">07</option>
                  <option value="08">08</option>
                  <option value="09">09</option>
                  <option value="10">10</option>
                  <option value="11">11</option>
                  <option value="12">12</option>
                  <option value="13">13</option>
                  <option value="14">14</option>
                  <option value="15">15</option>
                  <option value="16">16</option>
                  <option value="17">17</option>
                  <option value="18">18</option>
                  <option value="19">19</option>
                  <option value="20">20</option>
                  <option value="21">21</option>
                  <option value="22">22</option>
                  <option value="23">23</option>
                  <option value="24">24</option>
                  <option value="25">25</option>
                </select>
                <div class="invalid-feedback">
                  Please Select Batch
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-4">
                <label for="attendance_date">Attendance Date <span style="color: red">*</span></label>
                <datepicker  v-model="search_data.attendance_date" v-validate="'required'"
                             id="attendance_date" name="attendance_date"  :format="customAttendanceDate" placeholder="Attendance Date">
                </datepicker>
                <div class="text-danger"
                     v-if="errors.has('attendance_date')" style="margin-top: 0.25rem; font-size: 0.75rem;">
                  Attendance date required
                </div>
              </div>
            </div>
            <div class="form-row mt-2">
              <div class="col">
                <button class="btn btn-success waves-effect waves-light mr-2" @click.prevent="search">Search</button>
              </div>
            </div>
          </form>
        </b-card>
        <b-card v-if="!flag">
          <div class="row mb-2">
            <div class="col-sm-4">
              <span class="badge badge-success mr-2">Total Search Data Found: {{ batches.length }}</span>
            </div>
          </div>
          <div class="scrollable-table table-responsive" style="overflow-x: auto">
            <table class="table table-centered table-striped">
              <thead>
              <tr>
                <th>Sl</th>
                <th>Date</th>
                <th>Trade | Batch</th>
                <th>Venue</th>
                <th>Batch Trainees</th>
                <th>Enroll Trainees</th>
                <th>Male</th>
                <th>Female</th>
                <th>Present(%)</th>
                <th>Absent(%)</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(batch, index) in batches" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ attendanceDate(search_data.attendance_date) }}</td>
                <td>
                  <router-link :to="{
                                        name: 'batchView',
                                        params: { batch_id: batch.id }}" tag="a" target="_blank">{{ batch.trade.desc }} | {{
                    batch.batch_no }}
                  </router-link>
                </td>
                <td>{{ batch.venue.desc }}</td>
                <td>{{ batch.max_students }}</td>
                <td>{{ batch.totalTrainee }}</td>
                <td>{{ batch.traineeMaleCount }}</td>
                <td>{{ batch.traineeFemaleCount }}</td>
                <td>{{ batch.traineePresent }}({{ batch.present_percentage }})</td>
                <td>{{ batch.traineeAbsent }}({{ batch.absent_percentage }})</td>
              </tr>
              </tbody>
            </table>
            <h5 v-if="batches.length === 0" class="text-center text-secondary">
              No Data Found
            </h5>
          </div>
        </b-card>
      </div>
    </div>
  </Layout>
</template>

<script>
  import moment from "moment";
  import Datepicker from "vuejs-datepicker";

  import appConfig from "@src/app.config";
  import Layout from "@layouts/main";
  import PageHeader from "@components/page-header";
  import http from "@state/http";

  export default {
    page: {
      title: "Daily Attendance Report",
      meta: [{name: "description", content: appConfig.description}]
    },
    components: {Layout, PageHeader, Datepicker},
    data() {
      return {
        title: "Daily Attendance Report",
        items: [
          {
            text: "Dashboard",
            href: "/"
          },
          {
            text: "Daily Attendance Report",
            active: true
          }
        ],
        trades: [],
        batches: {},
        search_data: {
          trade_id: '',
          batch_no: '',
          attendance_date: ''
        },
        attendance_counts: {},
        current_date: "",
        flag: true
      };
    },
    mounted() {
      this.getTrades();
    },
    methods: {
      customAttendanceDate(date) {
        this.search_data.attendance_date = moment(date).format("YYYY-MM-DD");
        return moment(date).format("YYYY-MM-DD");
      },
      attendanceDate(date) {
        return moment(date).format("LL");
      },
      getTrades() {
        http.get("api/batch/trainee/getTrade").then(response => {
          if (!response.error) {
            this.trades = response.data.trades;
          }
        });
      },
      search() {
        this.$validator.validate().then(valid => {
          if (valid) {
            http.post("api/trainee/batch/daily-attendance/search", this.search_data)
                    .then(response => {
                      if (!response.error) {
                        this.flag = false;
                        this.batches = response.data.batches;
                        console.log(response)
                      }
                    })
                    .catch(error => {
                      this.validation_errors = error.response.data.errors;
                    });
          }
        });
      },
      countMale(trainees) {
        let count = 0;
        trainees.filter(p => {
          if (p.c_rep_gender_id !== null && p.c_rep_gender_id === 1) {
            count += 1;
          } else if (p.c_rep_gender_id === null && p.c_gender_id === 1) {
            count += 1;
          }
        });
        return count;
      },
      countFemale(trainees) {
        let count = 0;
        trainees.filter(p => {
          if (p.c_rep_gender_id !== null && p.c_rep_gender_id === 2) {
            count += 1;
          } else if (p.c_rep_gender_id === null && p.c_gender_id === 2) {
            count += 1;
          }
        });
        return count;
      },
      countPresent(attendances, max_students) {
        let count = 0;
        attendances.filter(p => {
          if (p.attendance_date === this.search_data.attendance_date && p.is_attend !== null && p.is_attend === 1) {
            count += 1;
          }
        });

        let percentage = (count * 100) / max_students;
        return percentage + '%';
      },
      countAbsent(attendances) {
        let count = 0;
        attendances.filter(p => {
          if (p.attendance_date === this.search_data.attendance_date && p.is_attend !== null && p.is_attend === 0) {
            count += 1;
          }
        });
        return count;
      },
    },

  };
</script>

<style lang="scss">
  .vdp-datepicker input {
    width: 100%;
    border-radius: 3px;
    border: 1px solid #ced4da;
    height: 30px;
    padding-left: 15px;
    color: #6b757d;
  }

  .c-container {
    margin-right: 5px;
  }
</style>